// src/components/ForgotPassword/ForgotPassword.jsx
import React, { useEffect, useState } from 'react'
import { sendPasswordReset } from '../../Api'
import ColorAlert from '../Snackbar/NewImplementations/ColorAlert/ColorAlert'
import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import { CircularProgress } from '@material-ui/core'
import useAlerts from '../Snackbar/NewImplementations/HooksAlerts/useAlerts'
import styles from './styles.module.css'

export default function ForgotPassword () {
  const { alerts, pushAlert, closeAlert, showValidationErrors } = useAlerts()
  const [email, setEmail] = useState('')
  const { register, handleSubmit, reset } = useForm()
  const history = useHistory()

  const [mutate, { isLoading }] = useMutation(
    ({ email }) => sendPasswordReset(email),
    {
      onSuccess (data) {
        if (data.status >= 400) {
          showValidationErrors({
            email: { message: 'Something went wrong, try again.' }
          })
        } else {
          reset()
          pushAlert({
            type: 'info',
            message: 'Check your email for password reset instructions'
          })
          setTimeout(() => history.push('/login'), 3000)
        }
      },
      onError (err) {
        showValidationErrors({ email: { message: String(err) } })
      }
    }
  )

  const handleInputChange = ({ target }) => {
    setEmail({ ...email, [target.name]: target.value })
  }

  const sendEmailReset = () => {
    mutate({ email })
  }

  useEffect(() => {
    document.title = 'Datafiniti Portal | Forgot Password'
  }, [])

  return (
    <section className={styles.mainContainer}>
      <div className={styles.background} />
      <div className={styles.contentContainer}>
        <div className={styles.containerInputs}>
          <img
            className={styles.imageForgotPassword}
            alt='DatafinitiLogo'
            src={require('../HomeDR12/images/datafiniti-logo-white.svg')}
          />
          <h1 className={styles.TitleForgotPassword}>Forgot password</h1>

          <form
            className={styles.formForgotPassword}
            onSubmit={handleSubmit(sendEmailReset, showValidationErrors)}
          >
            <div className={styles.containerFieldEmail}>
              <input
                className={styles.fieldEmail}
                name='email'
                placeholder='Email'
                autoComplete='off'
                {...register('email', {
                  required: 'Email is required',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i,
                    message: 'Invalid email format'
                  },
                  onChange: handleInputChange
                })}
              />
            </div>

            <div className={styles.buttonContainerForgotPassword}>
              <button
                className={styles.changeButtonEmail}
                type='submit'
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress size={24} style={{ color: '#FFFFFF' }} />
                ) : (
                  'Reset password'
                )}
              </button>
            </div>
          </form>

          <button
            className={styles.backToLoginForgotPassword}
            onClick={() => history.push('/login')}
          >
            Back to login
          </button>
        </div>
      </div>

      {/* render stacked client‐validation alerts */}
      {alerts.map((alert, i) => (
        <ColorAlert
          key={alert.id}
          open={alert.open}
          type={alert.type}
          label={alert.message}
          onClose={() => closeAlert(alert.id)}
          style={{ bottom: 20 + i * 80 }}
        />
      ))}
    </section>
  )
}
